import { all, call, takeEvery, put, fork } from "redux-saga/effects";
import actions from "./actions";
import API from "../../helpers/API";
import Notification from "../../components/notification";

export function* saveType() {
  yield takeEvery(actions.SAVE_TYPE, function* (action) {
    try {
      let resp, message;
      if (action.ticketTypeId) {
        resp = yield call(API.type.update, action.payload, action.ticketTypeId);
        message = "Ticket type updated successfully";
      } else {
        resp = yield call(API.type.add, action.payload);
        message = "Ticket type created successfully";
      }

      Notification("success", message);
      yield call(action.cb);
    } catch (err) {
      yield call(action.cb, "loader");
      Notification(
        "error",
        err && err.error ? err.error.message : "Request failed"
      );
    }
  });
}
export function* deleteType() {
  yield takeEvery(actions.DELETE_TYPE, function* (action) {
    try {
      yield call(API.type.delete, action.ticketTypeId);
      // const resp = yield call(API.grades.list);
      // yield put({
      //   type: actions.FETCH_GRADES_SUCCESS,
      //   grades: resp.data.grades,
      // });
      Notification("success", "Ticket type deleted successfully");
      yield call(action.spinHandler, false);
    } catch (err) {
      yield call(action.spinHandler, false);
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export default function* rootSaga() {
  yield all([fork(saveType), fork(deleteType)]);
}
